// extracted by mini-css-extract-plugin
module.exports = {"list_container":"slidermenu_list_container__3-zeE","nopres":"slidermenu_nopres__2MTUJ"};